import React from "react";
import Medallero from "components/medallero/medallero";
import CalendarioGangwon from "components/calendarios/calendarioGangwon/calendarioGangwon";
import { EDICIONES, TYPE_CALENDARIO, TYPE_MEDALLERO, TYPE_MEDALLERO_OVP, TYPE_MEDALLERO_OVP_MIN, TYPE_PLAYER_OVP, TYPE_RESULTADOS_DEPORTE, TYPE_RESULTADOS_GENERALES } from "constantes/constantes";
import MedalsOVP from "components/pluginOVP/medalsOVP";
import GeneralResultsOVP from "components/pluginOVP/generalResultsOVP";
import SportResultsOVP from "components/pluginOVP/sportResultsOVP";
import MedalsMiniOVP from "components/pluginOVP/medalsminiOVP";
import CalendarioParis from "components/calendarios/calendarioParis/calendarioParis";
import PlayerOVP from "components/pluginOVP/playerOVP";
import Envivo from "components/envivo/envivo";
import EnvivoDeporte from "components/envivoDeporte/envivoDeporte";
import Canales from "components/canales/canales";
import CalendarioParalimpicos from "components/calendarios/calendarioParalimpicos/calendarioParalimpicos";

export default function HomePage() {

  const url = window.location.href;
  const parametros = new URLSearchParams(new URL(url).search);

  // Obten valores específicos de los parámetros
  const valorParametro1 = parametros.get('longitud');
  const valorParametro2 = parametros.get('type');
  const valorParametro3 = parametros.get('edicion');
  const valorParametro4 = parametros.get('deporte');
  const valorParametro5 = parametros.get('titulo');

  const valorParametro6 = parametros.get('sessionid');
  const valorParametro7 = parametros.get('eventunitid');

  const valorParametro8 = parametros.get('urlMedallero');
  const valorParametro9= parametros.get('blank');

  const valorParametro10= parametros.get('num');
  const valorParametro11= parametros.get('opcion');
  const valorParametro12= parametros.get('verlistado');

  const valorParametro13= parametros.get('elementos');

  const valorParametro14= parametros.get('verFiltro');
  const valorParametro15= parametros.get('fecha');

  const PARIS = "paris";
  const PARALIMPICOS = "paralimpicos_paris";

  //PLUGIN RESULTADOS POR DEPORTE ->  /widgets/?type=resultados-deporte&edicion=paris&deporte=ATH&titulo=Atletismo
  //PLUGIN RESULTADOS GENERAL     ->  /widgets/?type=resultados-generales&edicion=paris
  //PLUGIN MEDALLERO COMPLETO     ->  /widgets/?type=medallero-ovp&edicion=paris&longitud=large
  //PLUGIN MEDALLERO SMALL        ->  /widgets/?type=medallero-ovp-min&edicion=paris&longitud=small&urlMedallero=https://www.clarosports.com/olimpicos/gangwon-2024/gangwon-2024-calendario/
  //PLUGIN CALENDARIO PARIS       ->  /widgets/?type=calendario&edicion=paris
  //PLUGIN PLAYER                 ->  /widgets/?type=player-ovp&edicion=paris&sessionid=6a00dc65-e2b6-478b-a6e1-64f480beb744&eventunitid=00000000-0000-0000-0000-000000000000
  // https://dev-cdn.clarosports.com/json/widgets_paralimpicos_paris/2024-09-02.json

  return (
    <>
      {/* medallero  react*/}
      {String(valorParametro2).toLowerCase() === TYPE_MEDALLERO && EDICIONES.includes(String(valorParametro3).toLowerCase())
        && <Medallero longitud={valorParametro1} seccion={String(valorParametro3).toLowerCase()} />
      }

      {/* calendario  react*/}
      {String(valorParametro2).toLowerCase() === TYPE_CALENDARIO && EDICIONES.includes(String(valorParametro3).toLowerCase()) && String(valorParametro3).toLowerCase() === String(PARIS).toLowerCase()
        ? <CalendarioParis seccion={String(valorParametro3).toLowerCase()} />
        : String(valorParametro2).toLowerCase() === TYPE_CALENDARIO && EDICIONES.includes(String(valorParametro3).toLowerCase()) && String(valorParametro3).toLowerCase() === String(PARALIMPICOS).toLowerCase() 
          ? <CalendarioParalimpicos seccion={String(valorParametro3).toLowerCase()} />
          : String(valorParametro2).toLowerCase() === TYPE_CALENDARIO && EDICIONES.includes(String(valorParametro3).toLowerCase()) && String(valorParametro3).toLowerCase() !== String(PARIS).toLowerCase()
          && <CalendarioGangwon seccion={String(valorParametro3).toLowerCase()} />
      }

      {/*************  COMPONENTES CON PLUGINS DE OVP *************/}
      {/* medallero ovp completo */}
      {String(valorParametro2).toLowerCase() === TYPE_MEDALLERO_OVP && EDICIONES.includes(String(valorParametro3).toLowerCase())
        && <MedalsOVP longitud={valorParametro1} />
      }

      {/* medallero ovp minificado */}
      {String(valorParametro2).toLowerCase() === TYPE_MEDALLERO_OVP_MIN && EDICIONES.includes(String(valorParametro3).toLowerCase())
        && <MedalsMiniOVP longitud={valorParametro1} urlBton={valorParametro8} targetB={valorParametro9}/>
      }

      {/* resultados generales */}
      {String(valorParametro2).toLowerCase() === TYPE_RESULTADOS_GENERALES && EDICIONES.includes(String(valorParametro3).toLowerCase())
        && <GeneralResultsOVP />
      }

      {/* resultados por deporte */}
      {String(valorParametro2).toLowerCase() === TYPE_RESULTADOS_DEPORTE && EDICIONES.includes(String(valorParametro3).toLowerCase())
        && <SportResultsOVP  deporte_name={String(valorParametro5)} arraySports={String(valorParametro4)} />
      }

      {/*  */}
      {String(valorParametro2).toLowerCase() === TYPE_PLAYER_OVP && EDICIONES.includes(String(valorParametro3).toLowerCase()) &&
        <PlayerOVP session_id={valorParametro6} event_unit={valorParametro7}/>
      }

      {/* widget envivo */}
      {String(valorParametro2).toLowerCase() === 'en-vivo' && EDICIONES.includes(String(valorParametro3).toLowerCase()) && 
        <Envivo seccion={String(valorParametro3).toLowerCase()} numCards={valorParametro10} tipo={valorParametro11} verListado={valorParametro12} targetB={valorParametro9}
        showFilter={valorParametro14} fechaProp={valorParametro15}/>
      }

      {/* widget envivo por deporte */}
      {String(valorParametro2).toLowerCase() === 'en-vivo-deporte' && EDICIONES.includes(String(valorParametro3).toLowerCase()) && 
        <EnvivoDeporte seccion={String(valorParametro3).toLowerCase()} deporte={String(valorParametro4)}/>
      }

      {/* widget listado canales */}
      {String(valorParametro2).toLowerCase() === 'canales' &&
        <Canales elementos={JSON.parse(valorParametro13)} seccion={String(valorParametro3).toLowerCase()}/>
      }
    </>
  )
}
